import { Heading } from '@/hen-ui/atomics/Heading';
import { Flex } from '@/hen-ui/composites/Flex';
import { cn } from '@/hen-ui/utils';

import type { CareerExplorerTrajectoryStep as CareerExplorerTrajectoryStepData } from './types';

interface CareerExplorerTrajectoryStepProps
  extends CareerExplorerTrajectoryStepData {
  current: boolean;
}

export const CareerExplorerTrajectoryStep = ({
  current,
  eyebrow,
  title,
  value,
}: CareerExplorerTrajectoryStepProps) => {
  const textColor = current ? 'secondary' : 'white';

  return (
    <Flex
      gap='xxs'
      className={cn(
        'w-full min-w-0 rounded-md border-2 p-sm md:flex-1 md:basis-0 lg:rounded-sm',
        current
          ? 'border-success-500 bg-white'
          : 'border-transparent bg-secondary-500',
      )}
      aria-current={current ? 'step' : undefined}
    >
      <Heading
        tag='p'
        variant='h5'
        color={textColor}
        className='uppercase font-semibold text-b5 md:text-h6 md:leading-h6'
      >
        {eyebrow}
      </Heading>
      <Heading
        tag='p'
        variant='h2'
        color={textColor}
        className='text-h4 md:text-h3 font-medium md:leading-h3'
      >
        {title}
      </Heading>
      <Heading
        tag='p'
        variant='h4'
        color={textColor}
        className='font-semibold text-h6 lg:text-h5 lg:leading-h5'
      >
        {value}
      </Heading>
    </Flex>
  );
};
